import React from 'react';
import type { NextPage } from 'next';

import BuoyMap from 'containers/BuoyMap';
import { getOrCreateStore, type ReduxInitialProps } from 'stores';

const BuoyMapPage: NextPage<
  {},
  ReduxInitialProps & { isMapV2Page: true; mapMode: 'buoy' }
> = () => <BuoyMap />;

BuoyMapPage.getInitialProps = async (context) => {
  const isServer = !!context.req;

  if (isServer) {
    const store = getOrCreateStore();
    return {
      isAppBannerEnabled: true,
      isFooterVisible: false,
      isMapV2Page: true,
      mapMode: 'buoy',
      ssrReduxState: store.getState(),
    };
  }

  return {
    isAppBannerEnabled: true,
    isFooterVisible: false,
    isMapV2Page: true,
    mapMode: 'buoy',
  };
};

export default BuoyMapPage;
